import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { theme } from '../styles/theme';
import ConfirmModal from './ConfirmModal';
import { deleteEvent } from './api';
import { useCurrentUser, isSuperAdmin } from './UserContext';
import { displayEventName } from './events';

// Bottone "Elimina evento" con conferma; visibile solo ai super-admin
function DeleteEventButton({ eventKey, eventName, backTarget }) {
  const user = useCurrentUser();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!isSuperAdmin(user) || !eventKey) {
    return null;
  }

  const handleDelete = async () => {
    setBusy(true);
    try {
      await deleteEvent(eventKey);
      toast.success('Evento eliminato');
      navigate(backTarget);
    } catch (error) {
      console.error('Error deleting event:', error);
      toast.error(error.message || "Errore nell'eliminazione dell'evento");
      setBusy(false);
      setOpen(false);
    }
  };

  return (
    <>
      <div style={styles.row}>
        <button type="button" onClick={() => setOpen(true)} style={styles.button}>
          Elimina evento
        </button>
      </div>
      {open && (
        <ConfirmModal
          title="Eliminare l'evento?"
          message={`Stai per eliminare "${displayEventName(eventName)}".\nL'operazione non può essere annullata; se l'evento ha un link di pagamento Stripe creato dall'app, verrà disattivato.`}
          confirmLabel="Elimina"
          busy={busy}
          onConfirm={handleDelete}
          onCancel={() => setOpen(false)}
        />
      )}
    </>
  );
}

const styles = {
  row: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 15px 20px 15px',
  },
  button: {
    padding: '6px 12px',
    backgroundColor: theme.colors.white,
    color: '#b70e0e',
    border: '1px solid #b70e0e',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  },
};

export default DeleteEventButton;
